import { render, staticRenderFns } from "./breakpoint.vue?vue&type=template&id=e96ef07c"
import script from "./breakpoint.vue?vue&type=script&lang=js"
export * from "./breakpoint.vue?vue&type=script&lang=js"
import style0 from "./breakpoint.vue?vue&type=style&index=0&id=e96ef07c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports